import React, { PureComponent } from 'react'
import styled from 'styled-components'
import TinyWeather from './Weather/TinyWeather'
import TinyCalendar from './Calendar/TinyCalendar'

const Wrapper = styled.div`
  font-size: 12px;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  display: -ms-flexbox;
  & .widget-tiny-actual__link {
    font-size: 12px;
  }
`

export default class DailyInfo extends PureComponent {
  render () {
    const {
      widgets
    } = this.props

    return (
      <Wrapper>
        <TinyWeather widget={widgets.weather}/>
        <TinyCalendar widget={widgets.calendar}/>
      </Wrapper>
    )
  }
}
